import { FileImage, FileSpreadsheet, FileText, FileType2, Presentation } from "lucide-react";

export const FILE_KINDS = {
  pdf: { label: "PDF", icon: FileText },
  docx: { label: "Word", icon: FileText },
  pptx: { label: "Slides", icon: Presentation },
  xlsx: { label: "Spreadsheet", icon: FileSpreadsheet },
  csv: { label: "CSV", icon: FileSpreadsheet },
  txt: { label: "Text", icon: FileType2 },
  markdown: { label: "Markdown", icon: FileType2 },
  image: { label: "Image", icon: FileImage },
};

export const FILTERS = [
  { key: "", label: "All" },
  { key: "pdf", label: "PDF" },
  { key: "docx", label: "Word" },
  { key: "xlsx", label: "Spreadsheets" },
  { key: "pptx", label: "Slides" },
  { key: "csv", label: "CSV" },
  { key: "image", label: "Images" },
];

export const ACCEPT = ".pdf,.docx,.pptx,.xlsx,.csv,.txt,.log,.md,.markdown,.png,.jpg,.jpeg,.webp,.gif";
export const MAX_FILE_MB = 20;
const EXTENSIONS = ACCEPT.split(",");

export function validateLocalFile(file) {
  const name = file.name.toLowerCase();
  if (!EXTENSIONS.some((ext) => name.endsWith(ext))) return "This file type isn't supported. Use PDF, DOCX, PPTX, XLSX, CSV, TXT, Markdown or an image.";
  if (file.size === 0) return "This file is empty.";
  if (file.size > MAX_FILE_MB * 1024 * 1024) return `Files can be up to ${MAX_FILE_MB} MB.`;
  return null;
}

export function formatBytes(bytes) {
  const n = Number(bytes || 0);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(n < 10240 ? 1 : 0)} KB`;
  if (n < 1024 ** 3) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 ** 3).toFixed(2)} GB`;
}

export const isProcessing = (f) => f?.status === "queued" || f?.status === "processing";
export const isReady = (f) => f?.status === "completed" && f?.ai_readable;

export function statusOf(f) {
  if (!f) return { label: "", tone: "muted" };
  if (f.status === "uploading") return { label: "Uploading", tone: "muted" };
  if (isProcessing(f)) return { label: f.status === "queued" ? "Queued" : "Reading file", tone: "busy" };
  if (f.status === "failed") return { label: "Couldn't read", tone: "error" };
  if (!f.ai_readable) return { label: "Stored", tone: "muted" };
  return { label: "Ready", tone: "ok" };
}
